export const locale = {
  week: {
    // Sunday = 0, Monday = 1.
    dow: 1,
  },
  months: {
    format:
      "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split(
        "_"
      ),
    standalone:
      "Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь".split(
        "_"
      ),
  },
  weekdaysShort: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  weekdaysMin: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
};
